import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import get from 'lodash/get'

import { LayoutPlain, Header } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { apiPayment } from 'helpers/decorators/api'
import PropTypes from 'prop-types'
import config from 'config'

@apiPayment()
class PaymentInit extends Component {
  static propTypes = {
    intializeMpg: PropTypes.func,
  }

  componentDidMount() {
    if (__SERVER__) {
      return
    }

    const { location, history, params } = this.props

    // Ugly hotfix to fix redirect in Chrome on Windows
    // This needs to be checked if we ever updated MPG
    if (location.hash.includes('__hc-action-complete')) {
      return history.push(`${config.publicPath}/mastercard-online-payments/success?authCode=${get(params, 'authCode')}`)
    }

    this.props.intializeMpg()
  }

  render() {
    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <div>
            <h1>
              <MaterialLoader />{' '}
              <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                <FormattedMessage
                  id="label.loading_payment_gateway"
                  defaultMessage="Loading Payment Gateway"
                />
              </span>
            </h1>
          </div>,
        ]}
      />
    )
  }
}

export default PaymentInit
